import { useState, useEffect } from 'react';
import useComponentTimeout from '../../Hooks/useComponentTimeout.js';

function useModalTransaction(current, transitionDuration) {
    const [changing, setChanging] = useState({ state: false, current });
    const setComponentTimeout = useComponentTimeout();
    useEffect(() => {
        if (changing.current !== current && !changing.state) {
            setChanging((s) => (Object.assign(Object.assign({}, s), { state: true })));
            setComponentTimeout(() => setChanging({ state: false, current }), transitionDuration);
        }
    }, [transitionDuration, changing, current, setComponentTimeout]);
    return changing;
}

export { useModalTransaction as default };
